import { createMerchThunks, createMerchSlice } from '@amzn/d2c-application-website-common';
import { RoadieService } from 'src/services/roadie';
import { awsRum } from 'src/rum';

const thunks = createMerchThunks(
  (_stage: string, csrfToken?: string) => new RoadieService(csrfToken),
  {
    error: (message, context) => { awsRum?.recordEvent('MerchError', { message, ...context }); },
    recordAPIError: (site, api, status) => { awsRum?.recordEvent('APIError', { site, api, status }); },
    recordAPIRequest: (site, api) => { awsRum?.recordEvent('APIRequest', { site, api }); },
  },
);

export const { fetchCollection } = thunks;
const merchSlice = createMerchSlice(thunks);
export const { replaceMerchState } = merchSlice.actions;
export default merchSlice.reducer;

export {
  selectGetCollectionInProgress,
  selectCollections,
  selectMerchError,
} from '@amzn/d2c-application-website-common';
